import { Component, inject, OnInit } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { TranslationService } from './i18n/translation.service';
import { locale as ptLocale } from './i18n/vocabs/pt_PT';
import { locale as enLocale } from './i18n/vocabs/en_EN';
import { locale as esLocale } from './i18n/vocabs/es_ES';
import { locale as frLocale } from './i18n/vocabs/fr_FR';
import { TranslateModule } from '@ngx-translate/core';
import { ToasterComponent } from './components/toaster/toaster';
import { ToasterService } from './services/toast.service';
import { AuthService } from './services/auth.service';
import { PwaService } from './services/pwa.service';
import { GlobalDataService } from './services/global.data.service';
import { ThemeService } from './services/theme.service';
import { DEFAULT_THEME } from './models/theme.model';
import { TenantService } from './services/tenant.service';
import { BehaviorSubject } from 'rxjs';
import { AsyncPipe } from '@angular/common';

@Component({
	selector: 'app-root',
	imports: [RouterOutlet, TranslateModule, ToasterComponent, AsyncPipe],
	templateUrl: './app.html',
})
export class App implements OnInit {
	protected title = 'Loyalty Card';
	private auth = inject(AuthService);
	private translationService: TranslationService = inject(TranslationService);
	private toasterService: ToasterService = inject(ToasterService);
	private pwaService = inject(PwaService);
	private globalData = inject(GlobalDataService);
	private themeService = inject(ThemeService);
	private tenantService = inject(TenantService);
	public pwaCover$: BehaviorSubject<any> = new BehaviorSubject(null);

	constructor() {
		const subdomain = this.tenantService.getTenant();
		this.themeService.patchTheme(DEFAULT_THEME);

		if (subdomain) {
			this.globalData.subdomain$.next(subdomain);
			this.pwaService.getPwaThemes(subdomain).subscribe({
				next: (res) => {
					this.globalData.pwaInfo$.next(res);
				},
				error: (res) => {
					this.toasterService.showError('toast_pwa_get_error');
				},
			});
		}

		this.globalData.pwaImage$.subscribe({
			next: (res) => {
				this.pwaCover$.next(res);
			},
		});

		this.globalData.pwaInfo$.subscribe({
			next: (res) => {
				const pwaTheme = res?.theme;
				const pwaLogo = res?.logo?.path;
				const pwaImg = res?.cover?.path;

				this.themeService.patchTheme(pwaTheme);

				this.globalData.pwaLogo$.next(pwaLogo);

				this.globalData.pwaImage$.next(pwaImg);
			},
		});
	}

	ngOnInit(): void {
		this.translationService.loadTranslations(ptLocale, enLocale, esLocale, frLocale);
		this.translationService.setLanguage(this.translationService.getSelectedLanguage());
	}
	getImageUrl(path: string) {
		if (path) {
			return path;
		} else {
			return 'assets/media/default-bg.jpg';
		}
	}
	removeToast(id: string) {
		this.toasterService.removeToast(id);
	}
}
